/** Public booking policy shared by the website and Instagram. */
export const AUTO_CONFIRM_MAX_PARTY = 10;
export const EMAIL_GROUP_MIN_PARTY = AUTO_CONFIRM_MAX_PARTY + 1;

export function requiresEmailBooking(bookingType: string, partySize: number) {
  return partySize > AUTO_CONFIRM_MAX_PARTY || bookingType === "karaoke";
}